import React, { useState, useEffect, Fragment } from 'react';
import {
    Card, CardBody, Input, ButtonGroup, Button, Row, Modal,
    ModalHeader,
    ModalBody,
    CustomInput
} from 'reactstrap';

import {
    Separator, Colxx
} from '../../../../../components/common/CustomBootstrap';

export default function BubblePosition({ botSettings, saveIntegration }) {

    /** other Digital Assistant state */
    const [edit, setEdit] = useState(false);
    const [settings, setSetting] = useState(botSettings.bubbleSettings.bubblePosition);
    const [hideBox, setHideBox] = useState(botSettings.hideSendBox);

    const handleChange = e => {
        const value = e.target.value;
        setSetting({
            ...settings,
            [e.target.name]: value,
        });
    };

    const handleSave = () => {
        botSettings.bubbleSettings.bubblePosition = settings
        botSettings.hideSendBox = hideBox;
        setEdit(!edit);
        saveIntegration({ botSetting: botSettings });
    };

    const handleCheckChange = e => {
        setHideBox(e.target.checked)
    };

    const Show = () => {
        return (
            <Fragment>
                {botSettings ? (
                    <CardBody>
                        <div className="text-center">
                            <h6>Position:</h6>
                            <Separator className="mb-3" />
                            <div className="mb-1">
                                <b>Alignment:</b> {botSettings.bubbleSettings.bubblePosition.align}
                            </div>
                            <div className="mb-1">
                                <b>Alignment Margin:</b> {botSettings.bubbleSettings.bubblePosition.side}px
                            </div>
                            <div className="mb-1">
                                <b>Bottom Margin:</b> {botSettings.bubbleSettings.bubblePosition.bottom}px
                            </div>              
                            <Button
                                size="xs"
                                color="success"
                                outline
                                style={{ marginTop: '20px' }}
                                onClick={() => {
                                    setEdit(!edit);
                                }}
                            >
                                Edit
              </Button>
                        </div>
                    </CardBody>
                ) : null}
            </Fragment>
        );
    };

    function Edit() {
        return (
            <Fragment>
                {botSettings ? (
                    <CardBody>
                        <div className="text-center">
                            <h6>Position</h6>
                            <Separator className="mb-3" />
                            <div className="mb-1">
                                <b>Alignment</b>
                                <br />
                                <Input
                                    name="align"
                                    type="select"
                                    defaultValue={botSettings.bubbleSettings.bubblePosition.align}
                                    onChange={handleChange}
                                >
                                    <option value="Left">Left</option>
                                    <option value="Right">Right</option>
                                </Input>
                            </div>
                            <div className="mb-1">
                                <b>Alignment Margin (px)</b>
                                <br />
                                <Input
                                    name="side"
                                    type="number"
                                    defaultValue={botSettings.bubbleSettings.bubblePosition.side}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="mb-1">
                                <b>Bottom Margin (px)</b>
                                <br />
                                <Input
                                    name="bottom"
                                    type="number"
                                    defaultValue={botSettings.bubbleSettings.bubblePosition.bottom}
                                    onChange={handleChange}
                                />
                            </div>

                



                            <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                <Button color="primary" size="xs" outline onClick={handleSave}>
                                    Save
                </Button>
                                <Button
                                    size="xs"
                                    color="dark"
                                    outline
                                    onClick={() => {
                                        setEdit(!edit);
                                    }}
                                >
                                    Cancel
                </Button>
                            </ButtonGroup>
                        </div>
                    </CardBody>
                ) : null
                }

            </Fragment >
        );
    }

    return <Card className="mb-4">{edit ? Edit() : Show()}</Card>;
}
